import { SourceSystem } from '@atlassian/cssxp-typescommon';
import { BillingDocWithLineItems } from '@atlassian/cssxp-types-billing';
import * as React from 'react';
import BillingDocContactDetailBlock from './billing-doc-contact-detail';
import BillingShippingDocDetailBlock from './billing-shipping-doc-detail';
import { SummarySectionV2 } from '../../../application';
import upperCase from 'lodash/upperCase';
import './billing-doc-details.scss';

interface Props {
  additionalContent: React.ReactNode;
  billingDoc?: BillingDocWithLineItems;
}

// Common Billing Doc Details: Contacts and Dates
const BillingDocDetailsV2 = ({ additionalContent, billingDoc }: Props) => {
  return (
    <>
      {billingDoc?.sourceSystem && upperCase(billingDoc?.sourceSystem) === SourceSystem.CCP ? (
        <>
          <SummarySectionV2.SummaryGridCalloutItem styles={{ gridRow: '1' }}>
            <div className="summary-item" style={{ display: 'inline-block', margin: '0 0 30px 32px' }}>
              <h4 className="summary-item-title">Bill to</h4>
              <BillingShippingDocDetailBlock contact={billingDoc?.billTo} block={'billTo'} />
            </div>
          </SummarySectionV2.SummaryGridCalloutItem>

          <SummarySectionV2.SummaryGridCalloutItem styles={{ gridRow: '1' }}>
            <div className="summary-item" style={{ display: 'inline-block' }}>
              <h4 className="summary-item-title">Sold to</h4>
              <BillingShippingDocDetailBlock contact={billingDoc?.shipTo} block={'shipTo'} />
            </div>
          </SummarySectionV2.SummaryGridCalloutItem>
        </>
      ) : (
        <>
          {billingDoc && (
            <SummarySectionV2.SummaryGridCalloutItem styles={{ gridRow: '1' }}>
              <div className="summary-item" data-testid="billing-contact" style={{ display: 'inline-block' }}>
                <h4 className="summary-item-title">Billing contact</h4>
                <BillingDocContactDetailBlock contact={billingDoc?.billTo} />
              </div>
            </SummarySectionV2.SummaryGridCalloutItem>
          )}
          {billingDoc && (
            <SummarySectionV2.SummaryGridCalloutItem styles={{ gridRow: '1' }}>
              <div className="summary-item" data-testid="technical-contact" style={{ display: 'inline-block' }}>
                <h4 className="summary-item-title">Technical contact</h4>
                <BillingDocContactDetailBlock contact={billingDoc?.shipTo} />
              </div>
            </SummarySectionV2.SummaryGridCalloutItem>
          )}
        </>
      )}
      {/* Displays Issued/Paid/PO Number on Invoice summary */}
      {additionalContent}
    </>
  );
};

export default BillingDocDetailsV2;
